export const stateCodeMapping: Record<string, string> = {
  "Baja California": "BC",
  Aguascalientes: "AG",
  "Mexico City": "DF",
  "Ciudad de México": "DF", //Alternative
  Chihuahua: "CI",
  Veracruz: "VC",
  "Quintana Roo": "QI",
  Mexico: "MX",
  "State of Mexico": "MX", //Alternative
  Durango: "DG",
  Coahuila: "CH",
  Jalisco: "JA",
  "Nuevo Leon": "NL",
  Sonora: "SO",
  Yacatan: "YU",
  Puebla: "PU",
  Querétaro: "QE",
  Chiapas: "CS",
  "San Luis Potosi": "SL",
  Michoacán: "MC",
};

export const getStateCode = (stateName: string, stateCode: string) => {
  return stateCodeMapping[stateName] || stateCode;
};
